"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDayPicker = require("react-day-picker");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var DatePickerCalendarNavigation =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DatePickerCalendarNavigation, _Component);

  function DatePickerCalendarNavigation() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DatePickerCalendarNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DatePickerCalendarNavigation)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onPreviousClick", function () {
      _this.props.onPreviousClick();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onNextClick", function () {
      _this.props.onNextClick();
    });
    return _this;
  }

  (0, _createClass2.default)(DatePickerCalendarNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          showPreviousButton = _this$props.showPreviousButton,
          showNextButton = _this$props.showNextButton;
      var classes = (0, _classnames.default)('DatePickerCalendarNavigation', className);
      return _react.default.createElement("div", {
        className: classes
      }, showPreviousButton && _react.default.createElement(_Button.default, {
        className: "DayPicker-NavButton DayPicker-NavButton--prev",
        onClick: this._onPreviousClick
      }, _react.default.createElement(_Icon.default, {
        name: "chevron-left",
        size: 9
      })), showNextButton && _react.default.createElement(_Button.default, {
        className: "DayPicker-NavButton DayPicker-NavButton--next",
        onClick: this._onNextClick
      }, _react.default.createElement(_Icon.default, {
        name: "chevron-right",
        size: 9
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return DatePickerCalendarNavigation;
}(_react.Component);

exports.default = DatePickerCalendarNavigation;
(0, _defineProperty2.default)(DatePickerCalendarNavigation, "propTypes", _reactDayPicker.NavbarPropTypes);
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DatePickerCalendarNavigation, "DatePickerCalendarNavigation", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/DatePickerCalendarNavigation.jsx");
  leaveModule(module);
})();

;